export const SERVER_API = {API_URL: process.env.API_SERVER}